import { useEffect } from 'react';
import { useNavigate } from 'react-router';

import { useSignUpContext } from './SignUpContext';
import { useAuth } from '../../context/Auth';

import SignUpInitialForm from './SignUpInitialForm';
import SignUpFinalForm from './SignUpFinalForm';
import SignUpConfirmEmail from './SignUpConfirmEmail';

import HomeFrame from '../SignIn/HomeFrame';

const SignUp = () => {
  const { state } = useSignUpContext();
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (user) {
      navigate('/strategies');
    }
  }, [user]);

  return (
    <HomeFrame>
      {state.step === 'INITIAL_FORM' ? (
        <SignUpInitialForm />
      ) : state.step === 'FINAL_FORM' ? (
        <SignUpFinalForm />
      ) : (
        <SignUpConfirmEmail />
      )}
    </HomeFrame>
  );
};
export default SignUp;
